import BrowserChrome from './BrowserChrome';

export default function ChefAfter() {
  return (
    <BrowserChrome url="chefzeitoun.com">
      <div className="chef-after">
        <div className="m-nav">
          <div className="b">Chef Zeitoun</div>
          <div className="l">
            <span>Menu</span>
            <span>Reserve</span>
            <span>Private events</span>
          </div>
          <div className="c">Book a table</div>
        </div>
        <div className="hero-chef">
          <div>
            <h2>
              Heritage on the plate.
              <br />
              <em>Always in season.</em>
            </h2>
            <p>
              Levantine cooking, sourced locally, plated with intention. Join us for dinner six
              nights a week — or reserve the chef’s table for a private tasting.
            </p>
            <div className="cta">Reserve →</div>
          </div>
          <div className="dish" />
        </div>
        <div
          style={{
            padding: '8px 16px',
            fontSize: 9,
            color: '#a89879',
            borderTop: '1px solid rgba(245,234,208,.06)',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <span>Tue–Sun · 5 pm – 10 pm</span>
          <span>Built by WebNova</span>
        </div>
      </div>
    </BrowserChrome>
  );
}
